export const pathWithOrigin = (path: string): string => `${window.location.origin}${path}`
